import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function AddBanner() {
  const [formData, setFormData] = useState({
    title: "",
    image: "",
    categoryId: "",
  });
  const [data, setData] = useState([]);
  const [disableBtn, setDisableBtn] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getProductCategories();
  }, []);

  const handleInputChange = (e) => {
    const name = e.target.name;
    let value = e.target.value;

    if (name === "image") {
      setFormData({ ...formData, image: e.target.files[0] });
      return;
    }

    setFormData({ ...formData, [name]: value });
  };

  // Fetching Data
  const getProductCategories = async () => {
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/category/view-all-categories?status=Active&page=1&limit=100`,
        {
          headers: headers,
        }
      );
      if (response.data.statusCode === 200) {
        setData(response.data.result.categories);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      console.log("Formdata", formData);
      // return;
      setDisableBtn(true);
      const headers = {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("sansadToken")}`,
      };
      const formdata = new FormData();
      formdata.append("title", formData.title);
      formdata.append("image", formData.image);
      // formdata.append("categoryId", formData.categoryId);
      if (formData.categoryId) {
        formdata.append("categoryId", formData.categoryId);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/banner/create-banner`,
        formdata,
        { headers }
      );
      if (response.data.statuscode === 200) {
        toast.success(response?.data?.message);
        navigate(-1);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to add banner. Please try again.", error);
    }
    setDisableBtn(false);
  };

  console.log("Data", data);

  return (
    <>
      <Layout>
        <ToastContainer />
        <div>
          <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8 tracking-wide">
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-xl font-medium">Add Banner</h2>
            </div>
            <div className="mt-10" onSubmit={handleSubmit}>
              <form action="">
                <div className="">
                  <label htmlFor="" className="text-sm">
                    Title
                  </label>{" "}
                  <br />
                  <input
                    type="text"
                    className="border border-black h-[40px] px-3 w-full mt-2 rounded-sm !outline-none text-sm capitalize"
                    placeholder="Write Title"
                    name="title"
                    value={formData.title}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-4">
                  <label htmlFor="categoryId" className="text-sm">
                    Select Category
                  </label>{" "}
                  <br />
                  <select
                    name="categoryId"
                    value={formData.categoryId}
                    onChange={handleInputChange}
                    className="border border-black h-[40px] px-3 w-full mt-2 rounded-sm !outline-none text-sm capitalize"
                    id="categoryId"
                  >
                    <option value="">Select Category</option>
                    {data.map((item) => {
                      return (
                        <>
                          <option
                            value={item._id}
                            className="capitalize"
                          >
                            {item.title}
                          </option>
                        </>
                      );
                    })}
                    <option value="123456789">Home Banner</option>
                  </select>
                </div>
                {/* Category Image */}
                <div className="mt-4">
                  <label htmlFor="image" className="text-sm">
                    Category Image
                  </label>{" "}
                  <br />
                  <input
                    type="file"
                    className="block w-full text-sm text-slate-800 file:mr-4 file:px-6 file:py-2 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-slate-100 file:text-[#ff4141] cursor-pointer mt-2"
                    placeholder="Choose Picture"
                    name="image"
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="mt-8 text-end">
                  <button
                    type="submit"
                    className="bg-[#2c2c38] text-white h-[40px] px-8 rounded-md text-sm hover:bg-[#191919]"
                    disabled={disableBtn}
                  >
                    <i className="fa fa-plus"></i>{" "}
                    {disableBtn ? "Adding ..." : "Add Banner"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
}
